export const isProdEnv = () =>
  process.env.REACT_APP_HOST_ENVIRONMENT_NAME === "prod";

export const isDevEnv = () =>
  process.env.REACT_APP_HOST_ENVIRONMENT_NAME === "dev";

export const isTestEnv = () =>
  process.env.REACT_APP_HOST_ENVIRONMENT_NAME === "test";

export const isUatEnv = () =>
  process.env.REACT_APP_HOST_ENVIRONMENT_NAME === "uat";

export const IS_PROD_OR_UAT = isProdEnv() || isUatEnv();

const ENV_LABELS: Record<string, string> = {
  test: "Testiympäristö",
  uat: "Koulutusympäristö",
  dev: "Kehitysympäristö",
};

export const getEnvironmentLabel = (): string | null => {
  const env = process.env.REACT_APP_HOST_ENVIRONMENT_NAME;
  if (!env) return null;
  return ENV_LABELS[env] ?? null;
};
